// import "./bootstrap";
// import svg4everybody from "svg4everybody";
// import * as site from "./site/model.js";
// import Alpine from "alpinejs";
// import focus from "@alpinejs/focus";
import 'lazysizes';
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import { menuToggle } from "./site/menu";
import { themeToggler } from "./site/theme";
import { formProcessor } from "./site/form";
import { carouselInit } from "./site/carousel";
import { initPhotoReveal } from "./site/globalAnimations";

const init = function () {
    // Carousel for listicle
    carouselInit("carousel");
    initPhotoReveal('.photo-reveal');
    // Global methods
    themeToggler();
    menuToggle([
        "menuUser",
        "menuUserWrapper",
        "menuUserLinks",
        "menu-user__button",
    ]);
    menuToggle([
        "menuSite",
        "menuSiteWrapper",
        "menuSiteLinks",
        "menu-site__button",
    ]);
    formProcessor("formContacts");
};

init();
